import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { motion } from "framer-motion";
//eslint-disable-next-line
import Step1 from "../HowToTerp/Step-1.png";
//eslint-disable-next-line
import Step2 from "../HowToTerp/Step-2.png";
//eslint-disable-next-line
import Step3 from "../HowToTerp/Step-3.png";
//eslint-disable-next-line
import Step4 from "../HowToTerp/Step-4.png";

const steps = [
  { img: Step1, alt: "Step 1", label: "Step 1" },
  { img: Step2, alt: "Step 2", label: "Step 2" },
  { img: Step3, alt: "Step 3", label: "Step 3" },
  { img: Step4, alt: "Step 4", label: "Step 4" },
];

const HowTo = () => {
  let nav = useNavigate();

  const fadeUp = (delay = 0) => ({
    initial: { opacity: 0, y: 24, filter: "blur(4px)" },
    whileInView: { opacity: 1, y: 0, filter: "blur(0px)" },
    viewport: { once: true, margin: "-40px" },
    transition: { duration: 0.6, delay, ease: [0.25, 0.46, 0.45, 0.94] },
  });

  return (
    <>
      {/* ── Animated Background ── */}
      <div className="mesh-bg">
        <div className="mesh-orb" />
      </div>
      <div className="noise-overlay" />

      <div className="howto-container" style={{ position: "relative", zIndex: 2 }}>
        <div className="howto-card glass-card">
          {/* ── Back Button ── */}
          <motion.button
            onClick={() => nav(-1)}
            className="howto-back-btn"
            whileHover={{ scale: 1.08 }}
            whileTap={{ scale: 0.92 }}
            initial={{ opacity: 0, x: -12 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.4 }}
            aria-label="Go back"
          >
            <ArrowLeft size={22} />
          </motion.button>

          {/* ── Title ── */}
          <motion.h1
            style={{
              textAlign: "center",
              fontSize: "2rem",
              fontWeight: 800,
              color: "var(--text-primary)",
              marginTop: 24,
              marginBottom: 36,
              letterSpacing: "-0.02em",
              textTransform: "uppercase",
            }}
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.15 }}
          >
            How To Terp
          </motion.h1>

          {/* ── Step Images ── */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 0,
            }}
          >
            {steps.map((step, i) => (
              <motion.div
                key={step.label}
                className="step-image-wrapper"
                {...fadeUp(i * 0.1)}
              >
                <span className="step-badge">{step.label}</span>
                <img src={step.img} alt={step.alt} />
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default HowTo;